<template>
    <div>
        <h1 class="page-title"> Mobile Issues </h1>
        <Widget  class="">

            <b-button :to="{ name: 'NewPage'}" variant="info">Add Website</b-button>
        </Widget>

    </div>
</template>

<script>
  import axios from "axios";
  import { ApolloClient } from "apollo-client";
  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  export default {
    name: 'Subscriptions',
    components: { Widget },
    data(){
      return {
        completed: false,
        error: '',
        submitting: false,
        loading: true,
        userHasActivePlan: false,
        subscription: {},
        price:{
          starter: {base: 45, perPage: 0.0},
          pro:  {base: 155, perPage: 0.0},
          agency:  {base: 435, perPage: 0.0},
        },
        form: {
          numberOfPages: 150,

        }
      }
    },
    methods: {

    },
    mounted() {
    },
  };
</script>

<style lang="scss">

</style>
